import type { SchedulingPolicy } from '../../store/schema/SchedulingPolicy';
import getDurationInMinutes from 'bookings-c2-utils/lib/getDurationInMinutes';
import getDurationInDays from 'bookings-c2-utils/lib/getDurationInDays';
import type { SchedulingPolicyB2Schema } from 'bookings-shared/lib/c2/services/schema/schedulingPolicy';

// Map scheduling policy from B2 API response format to client format
export const mapSchedulingPolicyResponse = (input: SchedulingPolicyB2Schema): SchedulingPolicy => {
    return {
        leadTimeInMinutes: getDurationInMinutes(input?.minimumLeadTime || 'PT1H'),
        capTimeInDays: getDurationInDays(input?.maximumAdvance || 'P90D'),
        timeSlotIntervalInMinutes: getDurationInMinutes(input?.timeSlotInterval || 'PT30M'),
        allowStaffSelection: input?.allowStaffSelection ?? true,
        hasCustomServiceWindows: input?.hasCustomServiceWindows ?? false,
        leadTimeForBookingsInMinutes: getDurationInMinutes(input?.minimumLeadTime || 'PT1H'), //Not available in SchedulingPolicy
        leadTimeForCancellationsInMinutes: 60, //Not available in SchedulingPolicy
    };
};
